import gql from 'graphql-tag';

export default gql`
  mutation storeUpdate($input: UpdateStoreInput!) {
    storeUpdate(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
